import "../styles/show.css"
import { useRef } from "react";
import { Link } from "react-router-dom";

export default function Show(props) {
    let ContainerShowRef = useRef();
    const handleShow = () => {
        ContainerShowRef.current.classList.add('close');
    }
    return <>
        <div className="ShowContainer" ref={ ContainerShowRef } >
            <Link to="/Show/">
                <img src={ props.Show }  alt="show" />
            </Link>
            <button onClick={ handleShow } >
                x
            </button>
        </div>
    </>;
};